import { gsap } from 'gsap';
import type { ElementTweenFunction } from '../types';

export const makeBordersTransparent: ElementTweenFunction = ({
    target }
) => {

    const tween = gsap.set(target, {
        // autoAlpha: 1,
        onComplete: () => {
            const sw = document.getElementById("safari-wrapper")
            if (sw) sw.style.overflow = "visible"
            const sd = document.getElementById("styled-display")
            if (sd) sd.style.overflow = "hidden"

        }
    })

    return { tween, position: 0 };
};
